import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProductZoom from "../../components/ProductZoom";
import { useLazyReviewViewQuery } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const Reviews = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [details, setDetails] = useState({});
  const [transaction, settransaction] = useState({});
  const [booking, setbooking] = useState({});
  const [subscription, setsubscription] = useState({});
  const [recommendation, setrecommendation] = useState({});
  const [wallet, setwallet] = useState({});

  //RTK QUERY
  const [viewApi] = useLazyReviewViewQuery();

  // DETAILS VIEW
  const getView = () => {
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setbooking(res?.review);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"review-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Review Details
                </th>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>Booking ID</td>
                  <td>:</td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() =>
                        navigate("/booked-rooms-view", {
                          state: { type: "view", data: booking?.booking },
                        })
                      }
                    >
                      {booking?.booking?.booking_id
                        ? booking?.booking?.booking_id
                        : "-"}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Service Type</td>
                  <td>:</td>
                  <td>
                    {booking?.booking?.service_type
                      ? booking?.booking?.service_type
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>User Name</td>
                  <td>:</td>
                  <td>{booking?.user?.name ? booking?.user?.name : "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Rating</td>
                  <td>:</td>
                  <td>{booking?.rating ? booking?.rating : "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Review</td>
                  <td>:</td>
                  <td>{booking?.review ? booking?.review : "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
